import { Injectable } from '@angular/core';
import { deserialize, serialize } from 'src/app/shared/utils/json-parser';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  public getItem<T>(key: string): T {
    if (!window.localStorage.getItem(key)) {
      return undefined;
    }

    return deserialize<T>(window.localStorage.getItem(key));
  }

  public setItem<T>(key: string, item: T): void {
    window.localStorage.setItem(key, serialize(item));
  }

  public removeItem(key: string): void {
    window.localStorage.removeItem(key);
  }
}
